import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelAssistantIndex from './Index.vue';

/**
 * Teletel assistant (phase 1) — the account's own AI assistant on the same
 * tables Captain used, served entirely by Teletel endpoints. Lives in the
 * settings area, which is keep-alive, so it stays an eager import on purpose.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-assistant'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'teletel_assistant', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'teletel_assistant',
          meta: {
            permissions: ['administrator', 'assistant_manage'],
          },
          component: TeletelAssistantIndex,
        },
      ],
    },
  ],
};
